const serverSide: boolean = typeof window === undefined
export const redirectToPageInNewTab = (page: string) => {
  if (serverSide) return
  window.open(page, '_blank')
}
